<ib-plus-accordion class="ib-accordion--flex">
	<ib-plus-accordion-tab [selected]=true header="MMB_VOUCHER_REFUND_MODAL_TITLE">
		<div class="ib-box ib-box--big ib-box--empty ib-box--covid u-pt-none u-pb-none">
			<p class="ib-text ib-text--block">
				<span>{{ 'MMB_VOUCHER_DESCRIPTION_TEXT_1' | translate}}</span>
			</p>
			<p class="ib-text ib-text--block ib-text--bold u-mt">
				{{ "MMB_VOUCHER_HAVE_EXTRA" | translate }}
			</p>
			<p class="ib-text ib-text--block u-mt-xsmall" >
				{{ "MMB_VOUCHER_THE_REFUND_OF_EXTRAS" | translate }}
			</p>
			<p class="ib-text ib-text--block ib-text--bold u-mt">
				{{ "MMB_VOUCHER_NOT_KEEP_IN_RESERVATION" | translate }}
			</p>
			<p class="ib-text ib-text--block u-mt-xsmall">
				{{ "MMB_VOUCHER_CONTACT_WITH_SERVICE" | translate }}
			</p>
			<p class="ib-text ib-text--block">
				-{{ "MMB_BOOKING_INSURANCE_TEXT" | translate }}
			</p>
			<p class="ib-text ib-text--block">
				-{{ "MMB_VOUCHER_BUS_FLY" | translate }}
			</p>
			<p class="ib-text ib-text--block">
				-{{ "MMB_VOUCHER_BAG_AND_BOARD" | translate }}
			</p>
			<p class="ib-text ib-text--block">
				-{{ "SECTOR_HOTELS" | translate }}
			</p>
			<p class="ib-text ib-text--block">
				-{{ "SECTOR_CARS" | translate }}
			</p>
            <p class="ib-text ib-text--block">
				-{{ "MMB_FLEXIBILIZATION_REASON_INFO_NOT_KEEP_CONDITION_6" | translate }}
			</p>
            <p class="ib-text ib-text--block">
				-{{ "MMB_FLEXIBILIZATION_REASON_INFO_NOT_KEEP_CONDITION_7" | translate }}
			</p>
		</div>
	</ib-plus-accordion-tab>
</ib-plus-accordion>
